/*
 * @Author: brucexlliu
 * @Date: 2022-03-15 11:05:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-29 14:16:14
 * @Description: 空白页
 * @FilePath: /wemeet-web-activity/src/components/Blank/index.tsx
 */
import React, { useContext, useMemo } from 'react';
import AddButton from '../AddActivityBtn';
import '@tencent/tpm-meeting-active/lib/NonePanel/style';
import { AppContext } from '../../utils/browser/app-context';
import noneList from 'src/assets/imgs/none_panel_pic.png';
import beaconReport from '@utils/beacon';
import './index.scss';
interface Props {
  title?: string;
  desc?: string;
  showButton?: boolean;
  style?: object;
  type?: 'default' | 'table';
  url?: string;
  className?: string;
}

const Blank = (props: Props) => {
  const { title, showButton = false, desc = '', type = 'default', url, className } = props;
  const { isMobile, hostDetail } = useContext(AppContext);
  const openCreatePage = () => {
    beaconReport('eventplace_hostview_ management_list_newevent_null_click', {
      hostid: hostDetail.host_id,
    });
  };
  const btns = useMemo(
    () =>
      !isMobile && showButton
        ? [
            <div onClick={openCreatePage}>
              <AddButton />
            </div>,
          ]
        : [],
    [isMobile, showButton],
  );
  if (type === 'table') {
    return (
      <div className={`ma-none-panel is-center ma-none-panel--table ${className}`}>
        <div className="ma-none-panel__desc">{desc || '没有数据'}</div>
      </div>
    );
  }
  return (
    <div className={`ma-none-panel is-center blank ${className}`}>
      <img src={url || noneList} className="ma-none-panel__img blank-img" />
      {title && <div className="ma-none-panel__title">{title || ''}</div>}
      {desc && <div className="ma-none-panel__desc">{desc || '没有数据'}</div>}
      {btns && <div className="ma-none-panel__btns">{btns}</div>}
    </div>
  );
};

export default Blank;
